/* eslint-disable no-unused-vars */
export const enum PrimaryRoutes {
	Home = '/dashboard',
	AIAnalyst = '/ai-analyst',
	Contacts = '/contacts',
	ContactDetails = '/contacts/:contactId',
	Campaigns = '/campaigns',
	CXInsights = '/cx-insights',
	DataInsights = '/sales-insights',
	Help = '/help',
	OpsInsights = '/ops-insights',
	Settings = '/settings',
	SegmentBuilder = '/segments/builder',
	SegmentBuilderDetails = '/segments/builder/:segmentId',
	Segments = '/segments',
}
